import React from 'react';

const LoaiNganhPage = () => {
    return <div></div>;
};

export default LoaiNganhPage;
